import React, {useEffect} from "react";
import {observer} from "mobx-react";
import Card from "../../../../components/layouts/card/card";
import {CARD_SPACING_VARIANT} from "../../../../components/layouts/card/card.types";
import {FONT_VARIANT} from "../../../../components/fonts/font-props";
import FontHeading2 from "../../../../components/fonts/font-heading2/font-heading2";
import {Note, NOTE_TYPE} from "../../../../components/note/note";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import manageMerchantWalletStore from "../stores/manage-merchant-wallet-store";
import {FormFieldLine} from "../../../../components/form-field-line/form-field-line";
import {Input} from "../../../../components/inputs/input/input";
import Currency from "../../../../components/currency/currency";
import {BUTTON_VARIANTS} from "../../../../components/inputs/button-variants";
import {Button} from "../../../../components/inputs/button/button";

interface IAdminManageWalletProps {
    shopId: number;
}

const AdminManageWalletCard: React.FC<IAdminManageWalletProps> = observer(({ shopId }) => {
    useEffect(() => {
        manageMerchantWalletStore.load(shopId);
    }, [shopId]);

    return (
        <Card
            isLoading={manageMerchantWalletStore.isLoading || manageMerchantWalletStore.isSaving}
            spacingVariant={CARD_SPACING_VARIANT.SMAll}
        >
            <FontHeading2 variant={FONT_VARIANT.BOLD}>Wallet Management</FontHeading2>

            {!manageMerchantWalletStore.isLoading && !manageMerchantWalletStore.hasWallet && (
                <Note
                    type={NOTE_TYPE.INFORMATION}
                    body={<FontBody1>Merchant does not have a Wallet</FontBody1>}
                />
            )}

            {!manageMerchantWalletStore.isLoading && manageMerchantWalletStore.hasWallet && (
                <>
                    <FormFieldLine
                        label='Wallet Balance'
                    >
                        <Currency
                            amount={manageMerchantWalletStore.amount}
                            currencyCode={manageMerchantWalletStore.currency}
                            useNative={true}
                        />
                    </FormFieldLine>
                    <FormFieldLine
                        label='Amendment amount'
                        note='Can be positive or negative'
                    >
                        <Input
                            type="number"
                            adornment={<FontBody1>{manageMerchantWalletStore.currencySymbol}</FontBody1>}
                            value={manageMerchantWalletStore.amendmentAmount}
                            onChange={manageMerchantWalletStore.setAmendmentAmount}
                            disabled={manageMerchantWalletStore.isSaving}
                            temp
                            required={true}
                        />
                    </FormFieldLine>
                    <FormFieldLine
                        label='Amendment reason'
                        note="This will be displayed in the Billing History table in the Merchant's account"
                    >
                        <Input
                            type="text"
                            value={manageMerchantWalletStore.amendmentReason}
                            onChange={manageMerchantWalletStore.setAmendmentReason}
                            disabled={manageMerchantWalletStore.isSaving}
                            placeholder="Wallet balance amendment reason"
                            required={true}
                        />
                    </FormFieldLine>
                    <Button
                        text={`Apply ${manageMerchantWalletStore.amendmentAmount ? manageMerchantWalletStore.currencySymbol + manageMerchantWalletStore.amendmentAmount : ''} amendment`}
                        onClick={manageMerchantWalletStore.save}
                        disabled={manageMerchantWalletStore.isAmendmentDisabled}
                        variant={BUTTON_VARIANTS.PrimaryAccent}
                    />
                </>
            )}
        </Card>
    )
});

export default AdminManageWalletCard;